import React from 'react';
import { LoaderCont } from './Loaders/Loaders.styles';
import ProjectLoaders from './Loaders/ProjectLoaders';

const OpportunitiesLoader = () => {
  return (
    <LoaderCont>
      <ProjectLoaders />
      <ProjectLoaders />
    </LoaderCont>
  );
};

export default OpportunitiesLoader;
